export const DismissalDecisionEN = {
    "decisionDismissal": {
        "title": {
            "add": "Create dismissal decision",
            "update": "Update dismissal decision",
            "detail": "Detail dismissal decision"
        },
        "placeholder": {
            "no": "QD001",
            "decisionMaker": "Enter decision maker",
            "employee": "Enter dismissal employee",
            "reasonDecision": "Enter reason decision",
            "currentDepartment": "Current department",
            "currentJobPosition": "Current job job-job-position",
            "currentJobTitle": "Current job job-title",
            "description": "Description"
        },
        "label": {
            "no": "Decision No",
            "decisionDate": "Decision date",
            "decisionMaker": "Decision maker",
            "validityDate": "Validity date",
            "employee": "Please enter employee decision",
            "reasonDecision": "Decision reason",
            "currentDepartment": "Current department",
            "currentJobPosition": "Current job job-job-position",
            "currentJobTitle": "Current job job-title",
            "description": "Description"
        }
    }
}